import Typography from '@mui/material/Typography';
import AudioRecorder from 'components/AudioRecorder';
import Button from 'components/Button/Button';
import Dropdown from 'components/Dropdown';
import Modal from 'components/Modal/Modal';
import { bindTrigger, usePopupState } from 'material-ui-popup-state/hooks';
import Files from 'modules/files';
import React from 'react';
import * as fileService from 'services/files.service';
import { shortId } from 'utils';
import toast from 'utils/toast';
import { MediaAddIcon } from 'components/icons';

const MediaAttachment = ({ onSelect }) => {
  const [showFiles, setShowFiles] = React.useState(false);
  const [showAudio, setShowAudio] = React.useState(false);
  const [audio, setAudio] = React.useState(null);
  const popupState = usePopupState({
    variant: 'menu',
    popupId: 'media',
  });

  const toggleFileBrowser = () => {
    setShowFiles(!showFiles);
  };

  const toggleAudio = () => {
    setShowAudio(!showAudio);
  };

  const handleFileSelect = (file) => {
    toggleFileBrowser();
    onSelect(file);
  };

  const onAudioRecorded = (audio) => {
    setAudio(audio);
  };

  const onSaveAudio = async () => {
    try {
      audio.name = `recorded-audio-${shortId()}`;
      const resp = await fileService.addFile(null, audio, true);
      onSelect(resp);
      toggleAudio();
    } catch (e) {
      toast.error(e.message);
    }
  };

  return (
    <>
      <Dropdown
        options={[
          { key: 'file', children: 'Select File', onClick: toggleFileBrowser },
          { key: 'audio', children: 'Record Audio', onClick: toggleAudio },
        ]}
      >
        <Button
          size="small"
          variant="text"
          color="secondary"
          startIcon={<MediaAddIcon />}
          {...bindTrigger(popupState)}
        >
          Media
        </Button>
      </Dropdown>
      {showFiles && (
        <Modal
          open
          fullWidth
          title="Select file"
          maxWidth="lg"
          onClose={toggleFileBrowser}
        >
          <Files filePicker onFileSelect={handleFileSelect} />
        </Modal>
      )}
      {showAudio && (
        <Modal
          open
          fullWidth
          title="Please record your audio message below."
          maxWidth="xs"
          onClose={toggleAudio}
          actions={audio && <Button onClick={onSaveAudio}>Submit</Button>}
        >
          <Typography paragraph color="text.secondary">
            You can access your previously recorded audio messages in the File
            Storage section.
          </Typography>
          <AudioRecorder
            label="Record your message"
            onChange={onAudioRecorded}
          />
        </Modal>
      )}
    </>
  );
};

export default MediaAttachment;
